export default {
    // 供應商狀態
    STATUS_REQUEST: 'request',
    STATUS_APPLY: 'apply',
    STATUS_REJECT: 'reject'
}